import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionnairesService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/services/questionnaires.service';
import { Question, QuestionnaireDTO } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'hygiene-check-questionnaire-preview',
  templateUrl: './hygiene-check-questionnaire-preview.component.html',
  styleUrls: ['./hygiene-check-questionnaire-preview.component.scss']
})
export class HygieneCheckQuestionnairePreviewComponent implements OnInit {
  questionnaireId: string = '';
  questionnaire: QuestionnaireDTO;
  isCollapsed: boolean = true;
  additionalInfoSelected: any = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private config: AppConfig,
    private questionnaireService: QuestionnairesService,
    public layoutService: PHBHPLayoutPackageService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.questionnaireId = params['id'];
      this.layoutService.showLoader = true;
      this.questionnaireService.getQuestionnaireById(this.questionnaireId).subscribe((questionnaire: any) => {
        this.questionnaire = questionnaire;
        this.questionnaire.questions = this.questionnaire.questions.sort((a, b) => a.position - b.position);
        this.questionnaire.questions.forEach((question: Question) => {
          if (question.isCaption) return;
          question.answers = [];
          var answerOrder = 1;
          if (question.questionType?.skin === "Input") {

          } else {
            if (question.questionType?.answerOptions && question.questionType?.answerOptions.length > 0) {
              for (let i = 0; i < question.questionType.answerOptions.length; i++) {
                question.answers.push({
                  id: question.questionType.answerOptions[i].id,
                  userQuestionId: question.id,
                  statement: question.questionType.answerOptions[i].caption,
                  orderNumber: answerOrder
                });

                answerOrder++;
              }
            } else {
              if (question.questionType?.min != null && question.questionType?.max != null) {
                for (let i = question.questionType.min; i <= question.questionType.max; i++) {
                  question.answers.push({
                    id: i.toString(),
                    userQuestionId: question.id,
                    statement: i.toString(),
                    orderNumber: answerOrder
                  });

                  answerOrder++;
                }
              }
            }
          }
        });
      }, (error) => {
        this.layoutService.showLoader = false;
        console.error(error);
      }, () => {
        this.layoutService.showLoader = false;
      })
    });
  }

  onchildData(value) {
    switch (value.key) {
      case 'close':
        this.isCollapsed = !this.isCollapsed;
        break;
    }
  }

  navigateBackTo() {
    if (this.config.userData.roleName.roleId === 2) {
      this.router.navigate(['/hygiene-check-editor']);
    } else {
      this.router.navigate(['/hygiene-check-menu/hygiene-check-editor']);
    }
  }

  navigateToEdit() {
    this.router.navigate([`/questionnaire-editor/${this.questionnaireId}`]);
  }

  showInfoButton(question: Question): boolean {
    return question.showInfo || question.showFormalBasis;
  }

  onClickQuestionInfo(question: Question) {
    this.isCollapsed = !this.isCollapsed;
    this.additionalInfoSelected = {
      informationSection: question.showInfo ? question.infoSection : "",
      formalBasics: question.showFormalBasis ? question.infoFormalBasis : ""
    };
  }

  getAdditionalInfo(): any {
    return this.additionalInfoSelected ? this.additionalInfoSelected : { informationSection: '', formalBasics: '' };
  }

  isNumericalInput(question: Question): boolean {
    if(!question.questionType) return false;
    return question.questionType.skin === "Input" && question.questionType.onlyNumbers;
  }

  isInputQuestion(question: Question): boolean {
    if(!question.questionType) return false;
    return question.questionType.skin === "Input";
  }

  getInputSkin(skin: string): string {
    switch (skin) {
      case 'Star':
        return 'input-star';
      default:
        return '';
    }
  }

  getInputLabelSkin(skin: string): string {
    switch (skin) {
      case 'Star':
        return 'label-star';
      default:
        return '';
    }
  }

  getOptionsDisplay(question: Question): string {
    if(!question.questionType) return;
    if (this.isInputQuestion(question)) {
      return '';
    }

    if ((question.questionType.answerOptions && question.questionType.answerOptions.length > 0) || question.questionType.skin === "Star") {
      return 'questions-display';
    } else {
      return 'scale-display';
    }
  }
}
